"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dictionary = void 0;
// external
const function_1 = require("fp-ts/lib/function");
const t = __importStar(require("io-ts"));
/**
 * Helper to encode/decode a record with partial keys.
 * Copied from https://github.com/gcanti/io-ts/issues/429#issuecomment-655394345
 * @param keys - The possible dictionary keys
 * @param values - The possible dictionary values
 * @param name - (Optional) name of this dictionary
 * @returns The codec for a dictionary
 */
const dictionary = (keys, values, name) => (0, function_1.unsafeCoerce)(t.record(t.union([keys, t.undefined]), values, name));
exports.dictionary = dictionary;
//# sourceMappingURL=dictionary.js.map